export const RootAPI = 'https://staging-api.nec-fts.com/api/'
// export const RootAPI = 'https://172.30.47.118:5001/api/'
//export const RootAPI = 'https://172.30.47.118:5004/api/'
    




